// extracted by mini-css-extract-plugin
export default {"wrapper":"Gw-z","viewport":"Hw-z","container":"Iw-z","slide":"Jw-z"};